import { createSlice } from "@reduxjs/toolkit";

import { GetProductReviews } from "../../reduxApi/website/ProductReview";

const ProductReviewSlice = createSlice({
  name: "ProductReviews",
  initialState: {
    status: "idle",
    Reviews: [],
    error: null,
  },
  reducers: {
    addProductReviewAction: (state, action) => {
      console.log("action--->", action.payload);
      state.Reviews.push(action.payload)
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetProductReviews.pending, (state) => {
        state.status = "pending";
      })
      .addCase(GetProductReviews.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.Reviews = action.payload.data;
        console.log("Reviews Response:", state.Reviews);
      });
  },
});

export default ProductReviewSlice.reducer;
